/**
 * Auth Actions - All authentication endpoints as declarative actions
 *
 * Public (no auth):
 * - login, register, forgot-password, reset-password, refresh
 *
 * Protected (requires auth):
 * - me, logout, logout-all, sessions, revoke-session, stop-impersonate
 *
 * Injected into users entity (via injectActions):
 * - impersonate (row action)
 *
 * NOTE: providers action removed — auth providers are now exposed via
 * CapabilitiesRegistry (NEX-257). See plugins/auth-providers/src/index.ts.
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'

// Public actions
export { loginAction } from './login.action.js'
export { registerAction } from './register.action.js'
export { forgotPasswordAction } from './forgot-password.action.js'
export { resetPasswordAction } from './reset-password.action.js'
export { refreshAction } from './refresh.action.js'

// Protected actions
export { meAction } from './me.action.js'
export { logoutAction } from './logout.action.js'
export { logoutAllAction } from './logout-all.action.js'
export { sessionsAction } from './sessions.action.js'
export { revokeSessionAction } from './revoke-session.action.js'
export { stopImpersonateAction } from './stop-impersonate.action.js'
export { createTokenAction } from './create-token.action.js'
export { listTokensAction } from './list-tokens.action.js'
// revokeTokenAction: row action declarada directamente en personalTokenEntity.actions

// Injected row actions (not in authActions array - delivered via injectActions)
export { impersonateAction } from './impersonate.action.js'

// Import for array
import { loginAction } from './login.action.js'
import { registerAction } from './register.action.js'
import { forgotPasswordAction } from './forgot-password.action.js'
import { resetPasswordAction } from './reset-password.action.js'
import { refreshAction } from './refresh.action.js'
import { meAction } from './me.action.js'
import { logoutAction } from './logout.action.js'
import { logoutAllAction } from './logout-all.action.js'
import { sessionsAction } from './sessions.action.js'
import { revokeSessionAction } from './revoke-session.action.js'
import { stopImpersonateAction } from './stop-impersonate.action.js'
import { createTokenAction } from './create-token.action.js'
import { listTokensAction } from './list-tokens.action.js'

/** All auth module-scope actions (row-scope revokeTokenAction vive en personalTokenEntity) */
export const authActions: ActionDefinition[] = [
  loginAction,
  registerAction,
  forgotPasswordAction,
  resetPasswordAction,
  refreshAction,
  meAction,
  logoutAction,
  logoutAllAction,
  sessionsAction,
  revokeSessionAction,
  stopImpersonateAction,
  createTokenAction,
  listTokensAction
]
